import React from 'react';

const Blogs = () => {
    return (
        <div className='my-5'>
            <h3 className='text-center'>Blog page is coming soon....</h3>
        </div>
    );
};

export default Blogs;